import {
  taskCompletedNetMinutes,
  taskLunchMinutes
} from './taskCheckInTime';

/**
 * Group check-in segments into one Uppgiftstid display row per user+task.
 * Writes stay per segment (`PUT /api/check-ins/:id`); use `segments` for edit.
 */
export const aggregateTaskTimeEntries = (entries) => {
  if (!Array.isArray(entries) || entries.length === 0) {
    return [];
  }

  const groups = new Map();
  for (const entry of entries) {
    const key = `${entry.user_id}:${entry.task_id}`;
    if (!groups.has(key)) {
      groups.set(key, []);
    }
    groups.get(key).push(entry);
  }

  const rows = [];
  for (const [groupKey, group] of groups) {
    const segments = [...group].sort(
      (a, b) => new Date(a.check_in_time) - new Date(b.check_in_time)
    );
    const base = segments[0];
    const hasOpen = segments.some((segment) => !segment.check_out_time);
    const completed = segments.filter((segment) => segment.check_out_time);
    const timeSpent = taskCompletedNetMinutes(segments);
    const lunchMinutes = taskLunchMinutes(segments);
    const summaryParts = segments
      .map((segment) => (segment.summary || '').trim())
      .filter(Boolean);
    let latestOut = null;
    if (!hasOpen) {
      for (const segment of completed) {
        if (!latestOut || new Date(segment.check_out_time) > new Date(latestOut)) {
          latestOut = segment.check_out_time;
        }
      }
    }
    const sortTime = Math.max(
      ...segments.map((segment) =>
        new Date(segment.check_out_time || segment.check_in_time).getTime()
      )
    );

    rows.push({
      rowKey: groupKey.replace(':', '-'),
      user_id: base.user_id,
      user_name: base.user_name,
      task_id: base.task_id,
      task_title: base.task_title,
      check_in_time: base.check_in_time,
      check_out_time: hasOpen ? null : latestOut,
      time_spent: timeSpent,
      lunch_minutes: lunchMinutes,
      summary: summaryParts.length > 0 ? summaryParts.join(' · ') : null,
      segments,
      segmentCount: segments.length,
      _sortTime: sortTime
    });
  }

  rows.sort((a, b) => b._sortTime - a._sortTime);
  return rows.map(({ _sortTime, ...row }) => row);
};
